const baseStyle = {
  ml: 4,
  fontWeight: "light",
}

export default {
  baseStyle,
}
